module.exports = __webpack_public_path__ + "static/media/pazysalvoentidad.a1d0d210.png";